// extracted by mini-css-extract-plugin
export default {"cartItem":"OedqNnA7TB39awt1LGW7","accessoryOuterWrap":"mpeihvKyZbV4dJMHJaEv","accessoryWrap":"QODobtZdjTG0wRVU06yz","quantityWrap":"RDtDpzCWt4UybHlGi6E6"};